export const ENV = {
    PORT: process.env.PORT || 14924,
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'https://85.214.16.108',
};
